import React, { memo } from "react";
import { Stack, Typography } from "investira.react.components";
import { Loading } from "../../components/molecules";
import AtivosBlacklisItem from "./AtivosBlacklisItem";
const AtivosBlacklist = memo(props => {
  const {
    posicoes = [],
    onDelete,
    isLoading
  } = props;
  const handleDelete = (pEvent, pAtivo) => {
    pEvent.preventDefault();
    pEvent.stopPropagation();
    onDelete && onDelete(pAtivo.ativo_id);
  };
  if (isLoading) {
    return <Loading size={24} />;
  }
  return <Stack>
      <Stack>
        <Typography color="textSecondary" variant="caption">
          Ativos
        </Typography>
      </Stack>
      {posicoes.sort((a, b) => b.ativo_id - a.ativo_id).map(xAtivo => {
      return <AtivosBlacklisItem key={xAtivo.ativo_id} ativo={xAtivo} onClick={e => {
        handleDelete(e, xAtivo);
      }} />;
    })}
    </Stack>;
});
export default AtivosBlacklist;
